import PropTypes from "prop-types";

import AngleCirculeRight from "shared/components/utils/icons/AngleCirculeRight";
import DownArrow from "shared/components/utils/icons/DownArrow";
import Employee from "./employee/Employee";
import Loader from "shared/components/feedback/loading/Loader";
import React from "react";
import ToggleButton from "shared/components/inputs/button/ToggleButton";
import getEmployeeKey from "./employee/utils/getEmployeeKey";
import {
    GroupLabel,
    Wrapper,
    Column,
    WrapperGroup,
    WrapperAction,
} from "./Row.styles";

const MemoizedEmployee = React.memo(Employee);

const Row = ({ employees, groupBy, params }) => {
    const handleToggle = async (groupId) => {
        const key = "divGroup_" + groupId;
        const selector = "[id^='" + key + "']";
        let groupDiv = document.querySelectorAll(selector);
        if (groupDiv) {
            groupDiv.forEach((div) => {
                if (div.style.display === "") {
                    div.style.display = "none";
                } else {
                    div.style.display = "";
                }
            });
        }
    };

    let groupByIdField = groupBy + "Id";

    return (
        <>
            {employees.map((employee, i, employees) => {
                let element = groupBy && (
                    <Wrapper $groupHeader>
                        <Column>
                            <WrapperGroup>
                                <WrapperAction>
                                    <ToggleButton
                                        Icon1={
                                            <DownArrow
                                                color={
                                                    globalThis.config.colors
                                                        .black
                                                }
                                            />
                                        }
                                        Icon2={<AngleCirculeRight />}
                                        initialValue={true}
                                        LoadingIcon={
                                            <Loader
                                                height="1rem"
                                                width="1rem"
                                            />
                                        }
                                        onToggle={async () => {
                                            handleToggle(
                                                employee[groupByIdField]
                                            );
                                        }}
                                    />
                                </WrapperAction>
                                <GroupLabel>
                                    {employee[groupBy] ?? "No-Group"}
                                </GroupLabel>
                            </WrapperGroup>
                        </Column>
                    </Wrapper>
                );
                let showGroupHeader = false;
                let lastEmployee = null;
                if (i > 0) {
                    lastEmployee = employees[i - 1];
                }
                if (groupBy) {
                    if (
                        lastEmployee == null ||
                        lastEmployee[groupBy] !== employee[groupBy]
                    ) {
                        showGroupHeader = true;
                    }
                }
                return (
                    <React.Fragment
                        key={`allo_row_${getEmployeeKey(employee)}`}
                    >
                        {showGroupHeader ? element : ""}
                        <div
                            id={`divGroup_${employee[groupByIdField]}_${employee.userId}`}
                        >
                            <MemoizedEmployee data={employee} params={params} />
                        </div>
                    </React.Fragment>
                );
            })}
        </>
    );
};

Row.propTypes = {
    employees: PropTypes.array.isRequired,
    groupBy: PropTypes.string,
    params: PropTypes.object,
};

export default Row;
